import React from 'react';

import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { ReactComponent as Learn } from '../../../assets/icons/learn.svg';
import { MANAGE_COLLABORATORS_ROUTE } from '../../constants/auth';
import { CLICK_ACTION, MANAGE_COLLABORATORS } from '../../constants/tagManager';
import TagManagerService from '../../services/gtm/tagManagerService';
import { TRANSLATIONS_COLLABORATORS_DETAIL } from '../../translations/collaboratorsDetail';
import CardStatus from '../CardStatus/CardStatus';
import StyledButtonNE from '../StyledButtonNE/StyledButtonNE';
import './EmptyCollaborators.scss';

interface EmptyCollaboratorsProps {
  filtersApplied: boolean;
}

const EmptyCollaborators = ({ filtersApplied }: EmptyCollaboratorsProps) => {
  const { t } = useTranslation();

  const navigate = useNavigate();

  const onAddCollaborator = () => {
    navigate(MANAGE_COLLABORATORS_ROUTE);
    TagManagerService.pushEvent(CLICK_ACTION, MANAGE_COLLABORATORS);
  };

  return (
    <div className="empty-collaborators">
      {!filtersApplied ? (
        <>
          <Learn className="empty-collaborators-icon" />
          <div className="empty-collaborators-title">
            {t(TRANSLATIONS_COLLABORATORS_DETAIL.collaboratorsTable.empty.title)}
          </div>
          <div className="empty-collaborators-description">
            {t(TRANSLATIONS_COLLABORATORS_DETAIL.collaboratorsTable.empty.description)}
          </div>
          <StyledButtonNE buttonType="secondary" buttonSize="lg" action={onAddCollaborator} classes="add-collaborators">
            {t(TRANSLATIONS_COLLABORATORS_DETAIL.collaboratorsTable.empty.addCollaborators)}
          </StyledButtonNE>
        </>
      ) : (
        <div>
          <CardStatus
            type="informative"
            message={t(TRANSLATIONS_COLLABORATORS_DETAIL.collaboratorsTable.empty.noResults)}
          />
        </div>
      )}
    </div>
  );
};

export default EmptyCollaborators;
